type FixedSizes = 'tiny' | 'small' | 'medium' | 'large' | 'xlarge';
export type IconSize = number | FixedSizes;
export interface QuirkIconProps {
	size?: IconSize;
	icon: React.FC<React.SVGProps<SVGSVGElement>>;
	flex?: boolean;
	color?: string;
}

const iconSizes: Record<FixedSizes, number> = {
	tiny: 12,
	small: 16,
	medium: 20,
	large: 24,
	xlarge: 40
};

function getIconSizeValue(size: IconSize): number {
	return typeof size === 'number' ? size : iconSizes[size];
}

export const iconStyle = (size: IconSize, flex = false, color?: string) => {
	return {
		display: flex ? 'flex' : 'block',
		width: getIconSizeValue(size),
		height: getIconSizeValue(size),
		color
	};
};

export const QuirkIcon: React.FC<QuirkIconProps> = ({ size = 'medium', icon, flex = false, color }) => {
	const Icon = icon;
	return <Icon style={iconStyle(size, flex, color)} />;
};
